<template>
  <section id="admin-filter">
    <h4>Party filter</h4>
    <div class="form-group">
      <label for="party-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="party-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="party-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="party-name" v-model="entity.name"/>
    </div>
    <div class="form-group">
      <label for="party-brand" class="form-label">Brand</label>
      <select class="form-control" id="party-brand" v-model="entity.brand">
        <option value=""></option>
        <option v-for="(opt, i) in getSystemOptions('BRAND')" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="party-cat" class="form-label">Category *</label>
      <select class="form-control" id="party-cat" v-model="entity.category">
        <option value=""></option>
        <option value="SP">Service Provider</option>
        <option value="CORP">Corporate</option>
        <option value="OFFICE">Office</option>
      </select>
    </div>
    <div class="form-group">
      <label for="party-prov" class="form-label">Provider type</label>
      <select class="form-control" id="party-prov" v-model="entity.providerType">
        <option value=""></option>
        <option v-for="(opt, i) in getSystemOptions('VENDOR_TYPE')" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="oos" class="form-label">Out Of Service</label>
      <select class="form-control" id="oos" v-model="entity.outOfService">
        <option value=""></option>
        <option value="0">No</option>
        <option value="1">Yes</option>
      </select>
    </div>
    <div class="form-group">
      <label for="location-country" class="form-label">Country</label>
      <select class="form-control" id="location-country" v-model="entity.country">
        <option value=""></option>
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group" v-if="entity.country !== null && entity.country !== ''">
      <label for="party-name" class="form-label">Address </label>
      <input type="text" class="form-control" id="party-name" v-model="entity.address"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'PartyFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          code: '',
          name: '',
          category: null,
          brand: null,
          providerType: null,
          country: null,
          address: '',
          outOfService: ''
        }
      }
    },
    watch: {
      'entity.country' (newVal, oldVal) {
        if (newVal === null || newVal === '') {
          this.entity.address = ''
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// PartyFilter.vue?23ca21e1